export default "__VITE_ASSET__CNi$QSBz__"